import React from 'react'
import * as AppBar from '../AppBar'
import { compose } from 'recompose'
import Error from '../../pages/_error'
import withAuthorization from 'components/Session/withAuthorization'
import Base from './Base'
import { signout } from 'models/Auth'
import Router from 'next/router'

const Component = ({ children, style, statusCode, client }) => {
  if (statusCode) return <Error statusCode={statusCode} />

  const onLogout = async () => {
    await signout()
    client.resetStore()
    Router.push('/artist/login')
  }

  return (
    <div>
      <AppBar.Artist onLogout={onLogout} />
      <Base style={style}> {children} </Base>
    </div>
  )
}

const ComposedComponent = compose(withAuthorization(true, 'artist'))(Component)

export default ComposedComponent
